<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200 } = $AppState.theme.colors;

  export let color: string = primary200;
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M19.2008 9.30078H11.1008C10.1067 9.30078 9.30078 10.1067 9.30078 11.1008V19.2008C9.30078 20.1949 10.1067 21.0008 11.1008 21.0008H19.2008C20.1949 21.0008 21.0008 20.1949 21.0008 19.2008V11.1008C21.0008 10.1067 20.1949 9.30078 19.2008 9.30078Z"
    stroke={color}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M5.7 14.7H4.8C4.32261 14.7 3.86477 14.5104 3.52721 14.1728C3.18964 13.8352 3 13.3774 3 12.9V4.8C3 4.32261 3.18964 3.86477 3.52721 3.52721C3.86477 3.18964 4.32261 3 4.8 3H12.9C13.3774 3 13.8352 3.18964 14.1728 3.52721C14.5104 3.86477 14.7 4.32261 14.7 4.8V5.7"
    stroke={color}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
